/**
 * AAA IDP cookie reducer
 * 
 */

import { ACCEPT_COOKIES, DELETE } from '../../actions/types';
const initialState = false;
export default function (state = initialState, action) {
  switch (action.type) {
    case ACCEPT_COOKIES:
      return action.value;
    case DELETE:
      return false;
    default:
      return state;
  }
}